(function () {
  if (window.customElements.get('custom-popup')) return;

  class CustomPopup extends HTMLElement {
    static get observedAttributes() {
      return ['open'];
    }

    connectedCallback() {
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.style.display = 'none';

      this.addEventListener('dialog:force-close', () => this.hide());

      this.overlay = this.querySelector('[data-action="close"]');
      this.overlay?.addEventListener('click', () => this.hide());

      document.addEventListener('keydown', this.onKeyDown);

      if (window.Shopify?.designMode) {
        this.shopifySection = this.closest('.shopify-section');

        if (this.shopifySection && this.hasAttribute('handle-editor-events')) {
          this.shopifySection.addEventListener('shopify:section:select', (event) => {
            this.show(event.detail.load);
          });
          this.shopifySection.addEventListener('shopify:section:deselect', () => this.hide());
        }
      }

      if (this.open || window.Shopify?.designMode) return;

      if (!this.shouldAppearAutomatically()) return;

      const delay = (parseInt(this.getAttribute('apparition-delay') || '0', 10) || 0) * 1000;
      this.autoShowTimeout = window.setTimeout(() => this.show(), delay);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeyDown);
      window.clearTimeout(this.autoShowTimeout);
    }

    onKeyDown = (event) => {
      if (event.key === 'Escape' && this.open) {
        this.hide();
      }
    };

    get storageKey() {
      return `theme:custom-popup-${this.dataset.popupId}-dismissed`;
    }

    shouldAppearAutomatically() {
      if (this.dataset.displayFrequency === 'every_page_load') {
        return true;
      }

      return localStorage.getItem(this.storageKey) !== 'true';
    }

    get open() {
      return this.hasAttribute('open');
    }

    show(immediate = false) {
      if (this.open) return;

      this.setAttribute('open', immediate ? 'immediate' : '');
    }

    hide() {
      if (!this.open) return;

      if (this.dataset.displayFrequency === 'first_visit_only') {
        localStorage.setItem(this.storageKey, 'true');
      }

      this.removeAttribute('open');
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'open') return;

      if (newValue !== null && oldValue === null) {
        this.style.display = 'flex';
        document.documentElement.classList.add('lock');

        if (newValue === 'immediate') {
          this.style.opacity = '1';
          return;
        }

        this.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 300, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)' }
        );
        return;
      }

      if (newValue === null && oldValue !== null) {
        const animation = this.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 250, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)' }
        );

        animation.finished.then(() => {
          this.style.display = 'none';
          document.documentElement.classList.remove('lock');
        });
      }
    }
  }

  window.customElements.define('custom-popup', CustomPopup);
})();
